"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'db.operation.create': 'Utwórz',
    'db.operation.update': 'Aktualizuj',
    'db.operation.delete': 'Usuń',
    'db.operation.upsert': 'Upsert',
    'db.operation.createMany': 'Utwórz wiele',
    'db.operation.updateMany': 'Aktualizuj wiele',
    'db.operation.deleteMany': 'Usuń wiele',
    'db.operation.findFirst': 'Znajdź pierwszy',
    'db.operation.findMany': 'Znajdź wiele',
    'db.operation.findUnique': 'Znajdź unikalny',
    'db.operation.count': 'Policz',
    'db.operation.aggregate': 'Agreguj',
    'db.operation.groupBy': 'Grupuj według',
};
